export default "__VITE_ASSET__df878bcb__"